<template>
    <div>
      <div class="footer">
          <div class="inside">
            <div>
                <p class="company">北京心动好物文化传媒有限公司</p>
                <p class="phone">联系电话：13651176873</p>
                <p class="address">地址：北京市丰台区南四环西路188号一区4号楼2层2009号</p>
            </div>
<!--            <div>-->
<!--              <img class="qrCode" src="../assets/img/service.png" alt="">-->
<!--              <img class="qrCode" src="../assets/img/public.png" alt="">-->
<!--              <img class="qrCode download" src="@/assets/img/download.png" alt="">-->
<!--            </div>-->
          </div>
          <p class="recordNo">ICP备案号：© <a href="https://beian.miit.gov.cn" target="_blank">京ICP备2022017983号</a></p>
<!--          <p class="publicRecordNo">公安备案号: 11010502039658</p>-->
      </div>
    </div>
</template>

<script>
    export default {
        name: "bottom"
    }
</script>

<style scoped>
  .footer{
    /*width:1920px;*/
    /*width:100%;*/
    height:472px;
    padding-top:96px;
    background:url(../assets/img/footer1920-472.png) no-repeat center center;
    background-size:100% 100%;
  }
  .inside{
    /*height:180px;*/
    padding:0 319px 0 350px;
    margin:0 auto;
    display:flex;
    justify-content:space-between;
  }
  .company{
    font-family: 'PingFang Bold';
    font-size:30px;
    color:#fff;
    letter-spacing:2px;
    margin-bottom:78px;
  }
  .phone, .address{
    font-family: 'PingFang Light';
    font-weight:600;
    font-size:20px;
    color:#ADAFB1;
  }
  .phone{
    background:url(../assets/img/phone.png) no-repeat left center;
    background-size:22px 17px;
    padding-left:40px;
    margin-bottom:30px;
  }
  .address{
    background:url(../assets/img/address.png) no-repeat left center;
    background-size:18px 22px;
    padding-left:40px;
  }
  .qrCode{
    width:150px;
    height:180px;
    margin-right:55px;
  }
  .download{
    width:160px;
  }
  .qrCode:last-child{
    margin-right:0px;
  }
  .recordNo{
    font-family: 'PingFang Light';
    font-size:22px;
    color:#ADAFB1;
    text-align:center;
    margin-top:40px;
  }
  .recordNo a{
    font-family: 'PingFang Light';
    font-size:22px;
    color:#ADAFB1;
  }
  .publicRecordNo{
    font-family: 'PingFang Light';
    font-size:22px;
    color:#ADAFB1;
    text-align:center;
    margin-top:12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue